import React, { useEffect, useState } from "react";
import Modal from "../Modal";
import { useStateValue } from "../../utils/Provider/StateProvider";
import { db, store } from "../../utils/User/include/Authorize";
import DivFilter from "../FilterInput/DivFilter";
import { AiOutlineLoading3Quarters } from "react-icons/ai";

function RelativeHintAdditionModal({ title, onCloseHandler, defaultKey = "" }) {
  const [{ user }, dispatch] = useStateValue();

  const [saving, setSaving] = useState(false);
  const [relativeLabel, setRelativeLabel] = useState(defaultKey);
  const [relativeDesc, setRelativeDesc] = useState("");
  const [storedRelation, setStoredRelations] = useState();
  const [error, setError] = useState("");

  useEffect(() => {
    if (user) {
      // Getting my Relative Family
      db.collection("App")
        .doc("global")
        .collection("relations")
        .onSnapshot((snapshot) => {
          let data;

          snapshot.forEach((doc) => {
            let obj = doc.data();

            console.log(">>", obj);
            setStoredRelations(obj);
          });
        });
    }
  }, [user]);

  // Validated if the keys are repeated or not
  const validator = () => {
    let status = true;

    console.log(storedRelation);

    storedRelation &&
      storedRelation.data.forEach((item) => {
        Object.keys(item).forEach((key) => {
          console.log(key, relativeLabel);
          if (key.toLowerCase() === relativeLabel.toLowerCase()) {
            status = false;
          }
        });
      });

    return status;
  };

  // Reset:
  const handleReset = () => {
    setError("");
    setRelativeDesc("");
    setRelativeLabel("");
  };

  // Save to DB:
  const handleSaveMap = () => {
    const isValid = validator();
    if (relativeLabel.length === 0) {
      setError("Relative labels cannot be empty");
      return;
    } else if (isValid) {
      if (relativeDesc.length === 0) {
        setError("Provide description for " + relativeLabel.toLowerCase());
        return;
      }
    } else {
      setError(
        relativeLabel.toLowerCase() +
          " - label is already created, better use it! or use unique name"
      );

      return;
    }

    setError("");
    setSaving(true);

    if (user) {
      const relationData = [{ [relativeLabel.toLowerCase()]: relativeDesc }];
      const storedVal = storedRelation ? storedRelation.data : [];
      const newMap = [...storedVal, ...relationData];

      console.log(newMap);

      db.collection("App")
        .doc("global")
        .collection("relations")
        .doc("mapper")
        .set({ data: newMap })
        .then((res) => {
          handleReset();
        })
        .catch((error) => {
          dispatch({
            type: "NOTIFY_ERROR",
            error: error.message,
          });
          setError("Error occured in saving: ", error);
          setSaving(false);
        });

      setSaving(false);
    }
  };

  return (
    <div>
      <Modal title={title} onCloseHandler={() => onCloseHandler(true)}>
        <div className="linkFamily_modal_container">
          <label style={{ color: "black" }}>Relative labels:</label>
          <br />
          <DivFilter
            toFilter={storedRelation && storedRelation.data}
            search={relativeLabel}
          >
            <input
              className="linkfamily_modal_container__input"
              type="text"
              placeholder="uncle, grandfather, etc"
              value={relativeLabel}
              onChange={(e) => setRelativeLabel(e.target.value)}
            />
          </DivFilter>

          <label style={{ color: "black" }}>Relative labels:</label>
          <br />
          <input
            className="linkfamily_modal_container__input"
            type="text"
            placeholder="eg: GrandFather: Father of my Father"
            value={relativeDesc}
            onChange={(e) => setRelativeDesc(e.target.value)}
          />
          <br />

          <button onClick={() => handleSaveMap()}>
            {saving && (
              <AiOutlineLoading3Quarters className="loaderAnimation" />
            )}{" "}
            Save Description
          </button>

          <p className="error_missing_field">{error}</p>
        </div>
      </Modal>
    </div>
  );
}

export default RelativeHintAdditionModal;
